// TODO: move to bnp-core
export const BNP_COMMON_SERVICE_URL = '/api/bnp-common-service/graphql';
export const HASURA_SERVICE_URL = '/api/data/objects/stories/v1/graphql';
